<template>
<!-- select pizza type -->
    <div>
         <h2 class="Select_size_title">{{get_local_string.string_99}}
                                    <span class="bolletsNode">2</span>
                                </h2>
                                <div class="select_pizza_type">
                                    <div class="box_type" v-for="dough in getbox_details.dough" :key="dough.id">
                                        <label class="card">
                                            <input v-model="doughData.dough_id" @change="changeDough($event)"
                                                name="plan" :value="dough.id" class="radio" type="radio">
                                            <span class="plan-details">
                                                <div class="pizza_type_img">
                                                    <img :src="dough.icon" alt="">
                                                </div>
                                                <span class="plan-type">{{dough.name}}</span>
                                                <span class="desc_plans">
                                                    {{dough.desc}}
                                                </span>
                                            </span>
                                            <p class="fri_span">{{dough.note}}</p>
                                        </label>
                                    </div>
                        </div>
    </div>
</template>
<script>
 import $ from 'jquery';
  import { mapGetters } from 'vuex';
export default {
    name:'doughtil',
    props:['doughData' , 'getbox_details' , 'extra_sum'],
    methods:{
         // on change Dough
            changeDough(event) {
                $('.dough-size-price').hide();
                $('.select_size_btn').prop('checked', false);
                $('.dough-size-price').removeClass('active');
                let id = event.srcElement.value;
                $('.dough-' + id).fadeIn();
                $('.dough-' + id).first().find('.select_size_btn').prop('checked', true);
                this.doughData.size_id = parseInt($('.dough-' + id).first().find('input').val());
                // set default class img prod on change dough
                $('.image_prod img').attr('class', 'cleanstate');
                $('.image_prod img').addClass($('.dough-' + id).first().find('input').attr('data-class'));
                //   change prod title on change dough
                $('.size_item').text($('.dough-' + id).first().find('input').attr('data-title'));
                //get first size price
                this.doughData.price = (this.doughData.qty * $('.dough-' + id).first().find('input').attr('data-price') + parseFloat(this.extra_sum));
                $('.dough-' + id).first().addClass('active');
            },
    },
     computed:{
        ...mapGetters({
               get_local_string:'get_local_string'
        })
    },
}
</script>

<style lang="scss" scoped>
 .mb-100 {
        margin-bottom: 100px;
    }
   .Select_size_title {
        font-size: 14px;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
       color: black;
        margin-top: 25px;
    }
    .bolletsNode {
        border-radius: 500%;
        background: var(--active_color);
        color: black;
        height: 30px;
        width: 30px;
        transition: all 500ms ease-in-out;
        text-align: center;
        line-height: 30px;
        margin-left: -25px;
        position: absolute;
        left: 0px;
        margin-top: -8px;
    }

 .select_pizza_type {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 30px;

            .box_type {
                flex: 0 0 31%;
                margin-right: 10px;

                .card {
                    border-radius: 10px !important;
                    background-color: #ffffff69;
                    transition: 0.3s ease-in-out;

                    .radio {
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        background: #fff;
                        border: 1px solid #bbbbbb;
                        border-radius: 50%;
                        cursor: pointer;
                        height: 1.5em;
                        outline: none;
                        transition: background 0.2s ease-out, border-color 0.2s ease-out;
                        width: 1.5em;
                        font-size: inherit;
                        margin: 0;
                        position: absolute;
                        right: calc(1em + 2px);
                        top: calc(1em + 2px);
                        left: 0;
                        top: -10px;
                        right: 0;
                        margin-left: auto;
                        margin-right: auto;
                        
                    }

                    .radio:checked {
                        background: var(--active_color);;
                         border-color: var(--active_color);
                          &::after {
                        border: 2px solid black;
                        border-top: 0;
                        border-left: 0;
                        content: "";
                        display: block;
                        height: 0.75rem;
                        left: 25%;
                        position: absolute;
                        top: 50%;
                        transform: rotate(45deg) translate(-50%, -50%);
                        width: 0.375rem;
                    }
                    }

                    .radio::after {
                        border-top: 0;
                        border-left: 0;
                        content: "";
                        display: block;
                        height: 0.75rem;
                        left: 25%;
                        position: absolute;
                        top: 50%;
                        transform: rotate(45deg) translate(-50%, -50%);
                        width: 0.375rem;
                    }

                }

                .plan-details {
                    border-radius: 0.5em;
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    padding: 1em;
                    transition: border-color 0.2s ease-out;
                    background: var(--main_color);
                    border: 1px solid var(--active_color);
                    text-align: center;
                    padding: 14px 10px;
                    min-height: 114px;
                }

                .pizza_type_img {
                    margin: 10px 0px;

                    img {
                        cursor: pointer;
                        overflow: visible;
                        filter: grayscale(1);
                    }
                }

                .plan-type {
                    color: var(--active_color);
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 1.1em;
                    width: 100%;
                    text-align: center;
                    margin-bottom: 4px;
                    font-family: 'Montserrat', sans-serif;
                }

                .desc_plans {
                    color: #a7a4a4;
                    font-size: 13px;
                    font-family: 'Montserrat', sans-serif;
                }

                .fri_span {
                    position: absolute;
                    bottom: -30px;
                    font-size: 12px;
                    left: 0;
                    opacity: 1 !important;
                    right: 0;
                    color: black;
                    text-align: center;
                }
            }
        }

</style>